import EcoSpace from 'eco-design/base/eco-space';
import Balcony from '../../components/Balcony';
import BannerB1 from '../../components/BannerB/BannerB1';
import Compact from '../../components/Compact';
import EcoAi from '../../components/EcoAi';
import EcoflowApp from '../../components/EcoflowApp';
import Engineering from '../../components/Engineering';
import FooterTcA from '../../components/FooterTcA';
import HighlightsB1 from '../../components/HighlightsB/HighlightsB1';
import InputPowerAcPro from '../../components/InputPowerAcPro';
import MixInput from '../../components/MixInput';
import Plug from '../../components/Plug';
import PowerOceanA from '../../components/PowerOceanA';
import ProductContrast from '../../components/ProductContrast';
import ProductListStatusB from '../../components/ProductListStatusB';
import ScalableCapacity from '../../components/ScalableCapacity';
import SeamLess from '../../components/SeamLess';
import SmartLoad from '../../components/SmartLoad';
import SolarEnergy from '../../components/SolarEnergy';
import SolarIndoors from '../../components/SolarIndoors';
import SolarInput from '../../components/SolarInput';
import SolarLiving from '../../components/SolarLiving';
import StepPortal from '../../components/StepPortal';
import StreamSystems from '../../components/StreamSystems';
import WholeHouse from '../../components/WholeHouse';
import OnlineStoreRightsAcPro from '../../components/OnlineStoreRightsAcPro';
import VideoAnimation from '../../components/Engineering/VideoAnimation';
import ChoosePlanModule from '../../components/ChoosePlanModule';
import SectionA3 from '../../components/SectionA3';
import Essentials from '../../components/Essentials';
import SectionB1 from '../../components/SectionB1';
import SectionB2 from '../../components/SectionB2';
import Assistant from '../../components/Assistant';
import SolarPowerV2 from '../../components/SolarPower-V2';
import Certification from '../../components/Certification';
import { useRouter } from 'next/router';
import SectionListGraph from '../components/SectionListGraph';
import SectionGraphCompare from '../components/SectionGraphCompare';
import SectionCompare from '../components/SectionCompare';

export default function StatusItem() {
    const { locale = 'eu' } = useRouter();

    return (
        <>
            <BannerB1 />
            <EcoSpace hPc="160px" />
            <OnlineStoreRightsAcPro productName="Ultra" />
            <div className="product-box">
                <ProductListStatusB type="ultra" />
                <EcoSpace hPc="160px" />
                <VideoAnimation pageType="ultra" />
                <SolarEnergy />
                <SolarInput />
                <SectionListGraph />
                <SectionGraphCompare />

                <InputPowerAcPro productName="ultra" />
                <SectionA3 pageType="ultra" />
                <SolarPowerV2 />
                <Essentials pageType="ultra" />
                {locale !== 'uk' && <Plug pageType="normal" />}
                {/* <EcoSpace hPc="120px" />
                <StreamSystems /> */}
                {/* <MixInput /> */}
                {/* <ScalableCapacity /> */}

                <SectionB1 pageType="ultra" />
                <SectionB2 />
                {/* <SolarIndoors /> */}
                {/* <SolarLiving /> */}
                <div style={{ background: '#000' }}>
                    <EcoAi pageType="ultra" />
                    <SeamLess pageType="ultra" />
                    <Assistant pageType="ultra" />
                </div>
                <Engineering />
                {/* <ProductContrast /> */}
                <EcoSpace hPc="160px" />
                {/* <Certification /> */}
                <SectionCompare />
                <EcoSpace hPc="160px" hPad="100px" />
                <PowerOceanA productName="Ultra" />
                <EcoSpace hPc="160px" />
                <FooterTcA pageType="ultra" />
            </div>
        </>
    );
}
